import React, { Component } from "react";
import { TouchableOpacity, Image, View } from "react-native";
import TextView from "./TextView";
import { componentStyles, appStyles } from "../theme/styles";
import {
  greenDarkColor,
  greenLightColor,
  blueDarkColor,
  blueLightColor,
} from "../theme/colors";
import LinearGradient from "react-native-linear-gradient";
import { wp } from "../utils/responsive";

export default class ServiceInfoItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    var item = this.props.data;
    return (
      <TouchableOpacity
        onPress={this.props.onPress}
        style={[
          item.addtocart ? componentStyles.selectedService : null,
          // item.addtocart ? appStyles.shadow : { margin: 0 },
          { backgroundColor: "white" },
        ]}
      >
        {item.insurance && (
          <View
            // eslint-disable-next-line react-native/no-inline-styles
            style={{
              position: "absolute",
              zIndex: 100,
              elevation: 3,
              borderRadius: 12,
              top: -15,
              right: 5,
              width: wp(10),
              height: wp(10),
              backgroundColor: "white",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              style={{
                width: wp(7),
                height: wp(7),
                alignSelf: "center",
              }}
              resizeMode={"contain"}
              tintColor="black"
              source={require("../../assets/images/insurance.png")}
            />
          </View>
        )}

        <LinearGradient
          colors={
            item.addtocart
              ? [greenLightColor, greenDarkColor]
              : [blueLightColor, blueDarkColor]
          }
          style={[componentStyles.serviceInfoItemWraper]}
        >
          <Image
            source={{ uri: item.imageurl }}
            resizeMode={"contain"}
            tintColor="white"
            style={componentStyles.serviceImage}
          />
          <TextView
            numberOfLines={2}
            style={{
              fontSize: 12,
              color: "white",
              textAlign: "center",
              marginRight: 5,
              marginLeft: 5,
              marginBottom: 5,
            }}
          >
            {item.title}
          </TextView>
        </LinearGradient>
      </TouchableOpacity>
    );
  }
}
